import ReactDOM from 'react-dom';
import { useCallback, useEffect, useState } from 'react';

import PaymentMethods from './PaymentMethod';
import DonateForm from './Form';
import WireTransfer from './WireTransfer';

export default function Donate({ closeModal }) {
  const [currentPage, setCurrentPage] = useState('paymentMethod');

  const onCreditCardPress = () => {
    setCurrentPage('creditCard');
  };

  const onWireTransferPress = () => {
    setCurrentPage('wireTransfer');
  };

  const handleOutsideClick = useCallback(
    (e) => {
      const modalContent = document.querySelector('.donate-modal');
      if (modalContent && e.target.className === modalContent.className) {
        closeModal();
      }
    },
    [closeModal]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);

  return ReactDOM.createPortal(
    <div className="donate-modal">
      {currentPage === 'paymentMethod' && (
        <PaymentMethods
          onCreditCardPress={onCreditCardPress}
          onWireTransferPress={onWireTransferPress}
        />
      )}
      {currentPage === 'creditCard' && <DonateForm closeModal={closeModal} />}
      {currentPage === 'wireTransfer' && <WireTransfer />}
    </div>,
    document.getElementById('donate-modal')
  );
}
